import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/layout/home.vue"; // 页面整体布局
import secondaryMenu from "@/layout/secondaryMenu.vue"; // 页面整体布局
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter);

const routes = [{
  path: "/",
  redirect: "/login",
  hidden: true,
},
{
  path: "/login",
  name: "login",
  component: res => import("views/login/login.vue"),
},


{
  path: "/cockpit",
  name: "cockpit",
  noDropdown:true,
  meta: {
    title: "首页", 
      icon: "icon-shouye",
    noLayout:true,
    routerType: "",
    requireLogin: true,
    permissionPath: ['Government'],
  },
  component: res => import("views/cockpit2/index.vue"),
},
{
  path: "/F2C9CD28-7614-4F6D-B12E-5BE66294BB8F",
  name: "F2C9CD28-7614-4F6D-B12E-5BE66294BB8F", 
  hidden: true,
  component: res => import("views/cockpit/index.vue"),
},

//政府端- 企业详情
{
    name: 'cfCompanyDetail',
    path: "/zfCompany/companyDetail/:companyId/:manageType/:companyName",   
    hidden: true, 
    meta: {
      title: "产废企业详情", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],
    },
    component: res => import("views/zfCompany/companyDetail.vue"),
},
//企业端->企业信息
{
  path: "/qyCompany",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "企业信息",
    icon: "icon-qiye",
    permissionPath: ['Administrator','Company'],
  },
  children: [{
    path: "/qyCompany/basic",
    meta: {
      title: "基本信息",
      name: 'qyBasic',
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Administrator', 'Company'],

    },
    component: res => import("views/qyCompany/basic.vue"), 
  },
  {
    path: "/qyCompany/yearDangerWaster",
    meta: {
      title: "年度危废信息",
      name: 'qyBasic',
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Administrator', 'Company'],

    },
    component: res => import("views/qyCompany/yearDangerWaster.vue"),
  },

  ]
},  
//处置端->企业信息
{
  path: "/czCompany",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "企业信息",
   icon: "icon-qiye",
    permissionPath: ['Administrator','DealWith'],
  },
  children: [{
    path: "/czCompany/czBasic",
    meta: {
      title: "基本信息",
      name: 'czBasic',
        // icon: "icon-qiye",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Administrator', 'DealWith'],

    },
    component: res => import("views/qyCompany/czBasic.vue"),
  },
  {
    path: "/czCompany/czOther",
    meta: {
      title: "其他信息",
      name: 'czOther',
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Administrator', 'DealWith'],

    },
    component: res => import("views/qyCompany/czOther.vue"),
  }  
  ]
}, 
//企业端->数据报送
 {
    path: "/qyDataSub",
    component: Layout,
    noDropdown: true,
    meta: { 
      firstLevelMenu:true,
      permissionPath: ['Administrator','Company']
    },
    children: [{
      path: "/qyDataSub/index",
      meta: {
        requireLogin: true,
        title: "数据报送",  
        icon: "icon-shujubaosong",
        permissionPath: ['Administrator','Company']
      },
      component: res => import("views/qyDataSub/index.vue"),
    }],
},
//处置端->数据报送
{
  path: "/czDataSub",
  component: Layout,
  noDropdown: true,
  meta: { 
    firstLevelMenu:true,
    permissionPath: ['DealWith']
  },
  children: [{
    path: "/czDataSub/index",
    meta: { 
      title: "数据报送", 
      icon: "icon-shujubaosong",
      requireLogin: true,
      permissionPath: ['DealWith']
    },
    component: res => import("views/czDataSub/index.vue"),
  }],
}
,
//企业端->我的提醒
{
  path: "/qyWarning",
  component: Layout,
  noDropdown: true,
  meta: { 
    firstLevelMenu:true,
    permissionPath: ['Administrator','Company']
  },
  children: [{
    path: "/qyWarning/index",
    meta: {
      requireLogin: true,
      title: "我的提醒",  
      icon: "icon-tixing",
      permissionPath: ['Administrator','Company']
    },
    component: res => import("views/qyWarning/index.vue"),
  }],
},
//政府端->地图显示
{
  path: "/zfMap",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "地图显示",
    icon: "icon-ditu",
    permissionPath: ['Government'],
  },
  children: [{
    path: "/zfMap/category",
    name: 'categoryMap', 
    meta: {
      title: "管理类型", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/map/categoryMap.vue"),
  }, 
  {
    path: "/zfMap/type",
    name: 'typeMap', 
    meta: {
      title: "危废种类", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/map/dangerTypeMap.vue"),
  },
   
  ]
}, 
 
//政府端->企业信息
{
  path: "/zfCompany",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "一企一档",
    icon: "icon-qiye",
    permissionPath: ['Government'],
  },
  children: [{
    path: "/zfCompany/companies",
    name: 'zfCompanies', 
    meta: {
      title: "基本信息", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfCompany/index.vue"),
  }, 
  {
    path: "/zfCompany/emphasisCompanies",
    name: 'zfEmphasisCompanies', 
    meta: {
      title: "重点监管",   
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfCompany/emphasisCompanies.vue"),
  }  ,
  {
    path: "/zfCompany/greenCompanies",
    name: 'zfGreenCompanies', 

    meta: {
      title: "绿色企业",   
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfCompany/greenCompanies.vue"),
  }  
  ]
}, 

//政府端->业务总览
{
  path: "/zfStatistics",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "业务统计",
     icon: "icon-tongji",
    permissionPath: ['Government'],
  },
  children: [
    {
    path: "/zfStatistics/zonglan",
    name: 'zonglan', 
    meta: {
      title: "业务总览",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/zonglan.vue"),
  }, 
  {
    path: "/zfStatistics/manageCategory",
    name: 'manageCategory', 
    meta: {
      title: "管理类别",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/manageCategory.vue"),
  }, 
  {
    path: "/zfStatistics/dangerWasterData",
    name: 'dangerWasterData', 
    meta: {
      title: "危废数据",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/dangerWasterData/index.vue"),
  }, 
  {
    path: "/zfStatistics/dangerType",
    name: 'dangerType', 
    meta: {
      title: "危废种类",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/dangerType/index.vue"),
  }, 
  {
    path: "/zfStatistics/companyDanger",
    name: 'companyDanger', 
    meta: {
      title: "企业情况",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/companyDanger/index.vue"),
  }, 
  {
    path: "/zfStatistics/greenCompany",
    name: 'greenCompany', 
    meta: {
      title: "绿色统计",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfBusinessStatistics/greenCompany/index.vue"),
  }, 
  ]
}, 
//政府端->考核整改
{
  path: "/exam",
  component: Layout,
  noDropdown: true,
  meta: {  
    firstLevelMenu:true,
    permissionPath: ['Government']

  },
  children: [{
    path: "/exam/index",
    meta: {
      requireLogin: true,
      title: "考核整改",  
      icon:"icon-kaohe",
      permissionPath: ['Government']
    },
    component: res => import("views/exam/index.vue"),
  }],
},

//政府端->预警/警报
{
  path: "/zfWarning",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "预警/警报",
      icon: "icon-yujing",
    permissionPath: ['Government'],
  },
  children: [{
    path: "/zfWarning/charts", 
    meta: {
      title: "情况总览", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfWarning/charts.vue"),
  }, 
  {
    path: "/zfWarning/yujing", 
    name: 'zfYujing', 
    meta: {
      title: "预警汇总", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfWarning/warnings.vue"),
  }, 
  {
    path: "/zfWarning/jingbao", 
    name: 'zfJingbao', 
    meta: {
      title: "警报汇总", 
      // icon: "icon-shujuzonglan",
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'],

    },
    component: res => import("views/zfWarning/warnings.vue"),
  }, 
  ]
}, 

//政府端->实时监控
{
  path: "/monitor",
  component: Layout,
  noDropdown: true,
  meta: { 
    firstLevelMenu:true,
    permissionPath: ['Government']
  },
  children: [{
    path: "/monitor/index",
    meta: {
      requireLogin: true,
      title: "实时监控", 
      icon:"icon-jiankong", 
      permissionPath: ['Government']
    },
    component: res => import("views/monitor/index.vue"),
  }],
}, 
//环保手册
{
  path: "/envManualFile",
  component: Layout,
  noDropdown: true,
  meta: { 
    firstLevelMenu:true,
    permissionPath: ['Administrator','Company','DealWith','Government']
  },
  children: [{
    path: "/envManualFile/index",
    meta: {
      requireLogin: true,
      title: "环保手册",  
      icon:"icon-shouce",
      permissionPath: ['Administrator','Company','DealWith','Government']
    },
    component: res => import("views/envManualFile/index.vue"),
  }],
},
//更多服务
{
  path: "/moreServices",
  component: Layout,
  noDropdown: true,
  meta: { 
    firstLevelMenu:true,
    permissionPath: ['Administrator','Company','DealWith','Government']
  },
  children: [{
    path: "/moreServices/index",
    meta: {
      requireLogin: true,
      title: "更多服务",  
      icon: "icon-gengduofuwu",
      permissionPath: ['Administrator','Company','DealWith','Government']
    },
    component: res => import("views/moreServices/index.vue"),
  }],
},
 //政府端->设置
{
  path: "/setting",
  component: Layout,
  noDropdown: true,
  meta: {
    requireLogin: true,
    title: "设置",
  icon: "icon-shezhi",
    permissionPath: ['Government'],
  },
  children: [
    {
    path: "/setting/usersManage",
    name: 'usersManage', 
    meta: {
      title: "账号管理",  
      routerType: "",
      requireLogin: true,
      permissionPath: ['Government'], 
    },
    component: res => import("views/setting/usersManage.vue"),
  },  
  ]
},   
];

const router = new VueRouter({
  routes,
});

export default router;